import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Card, CardContent } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { useApi } from '../hooks/useApi';
import DoctorForm from '../components/DoctorForm';

export default function DoctorAddPage() {
  const navigate = useNavigate();
  const api = useApi();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const payload = {
        ...formData,
        opd_charge_nepali: formData.opd_charge_nepali ? parseFloat(formData.opd_charge_nepali) : null,
        opd_charge_international: formData.opd_charge_international ? parseFloat(formData.opd_charge_international) : null,
        online_charge_nepali: formData.online_charge_nepali ? parseFloat(formData.online_charge_nepali) : null,
        online_charge_international: formData.online_charge_international ? parseFloat(formData.online_charge_international) : null,
        email: formData.email || null,
        mobile_number: formData.mobile_number || null,
        nmc_id: formData.nmc_id || null
      };

      await api.post('/doctors', payload);
      toast.success('Professional created successfully');
      navigate('/doctors');
    } catch (error) {
      console.error('Failed to save:', error);
      toast.error(error.response?.data?.detail || 'Failed to save professional');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="p-6 max-w-4xl mx-auto">
        <div className="mb-6">
          <button onClick={() => navigate('/doctors')} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4">
            <ArrowLeft className="h-4 w-4" />
            <span>Back to Doctor Management</span>
          </button>
          <h1 className="text-2xl font-bold" style={{ color: "#652D90" }}>
            Add New Professional
          </h1>
          <p className="text-gray-600 mt-1">Fill in the details to add a new medical professional</p>
        </div>

        <Card>
          <CardContent className="p-6">
            <DoctorForm
              initialData={null}
              onSubmit={handleSubmit}
              onCancel={() => navigate('/doctors')}
              loading={loading}
            />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
